export interface ProjectParameters {
  TypologieProgramme: TypologieProgramme;
  ModaliteProgramme: ModaliteProgramme;
  DevolutonMarche: DevolutonMarche;
  Gamme: Gamme;
}

export type TypologieProgramme = 
  | 'Logement'
  | 'Tertiaire'
  | 'Commerce'
  | 'Hôtel'
  | 'Industrie';

export type ModaliteProgramme = 
  | 'Neuf'
  | 'Réhabilitation'
  | 'Restructuration'
  | 'Rénovation Light'
  | 'Rénovation Lourde';

export type DevolutonMarche = 
  | 'Entreprise Générale'
  | 'Contractant Général'
  | 'Macro-Lot'
  | 'Corps d\'État Séparés';

export type Gamme = 
  | 'Moyenne'
  | 'Haute'
  | 'Très Haute';

export const TYPOLOGIE_PROGRAMME_OPTIONS: TypologieProgramme[] = [
  'Logement',
  'Tertiaire',
  'Commerce',
  'Hôtel',
  'Industrie'
];

export const MODALITE_PROGRAMME_OPTIONS: ModaliteProgramme[] = [
  'Neuf',
  'Réhabilitation',
  'Restructuration',
  'Rénovation Light',
  'Rénovation Lourde'
];

export const DEVOLUTION_MARCHE_OPTIONS: DevolutonMarche[] = [
  'Entreprise Générale',
  'Contractant Général',
  'Macro-Lot',
  'Corps d\'État Séparés'
];

export const GAMME_OPTIONS: Gamme[] = [
  'Moyenne',
  'Haute',
  'Très Haute'
];

// Helper function to get parameter labels
export const getParameterLabel = {
  TypologieProgramme: 'Typologie de programme',
  ModaliteProgramme: 'Modalité de programme',
  DevolutonMarche: 'Dévolution du marché',
  Gamme: 'Gamme'
};

// Helper function to get parameter descriptions
export const getParameterDescription = {
  TypologieProgramme: 'Type de construction ou d\'aménagement',
  ModaliteProgramme: 'Nature des travaux à réaliser',
  DevolutonMarche: 'Mode d\'organisation du chantier',
  Gamme: 'Niveau de finition et de qualité'
};
